import type { oz } from '@weft/utils';
import { NewBillingSettingsSchema } from './new-billing-settings-schema';

export const BillingSettingsSchema = NewBillingSettingsSchema.openapi('BillingSettings');

export type BillingSettings = oz.infer<typeof BillingSettingsSchema>;